import request from '../request';

function query(q) {
  return request({
    url: `/book/findAll`,
    method: 'get',
    params:{"q":q}
  });
}

function show(id) {
  return request({
    url: `/book/show/${id}`,
    method: 'get'
  });
}

function add(params) {
  return request({
    url: '/book/add',
    method: 'post',
    data: params
  });
}

function update(id,params) {
  return request({
    url: `/book/update/${id}`,
    method: 'post',
    data: params
  });
}

function findBook() {
  return request({
    url: `/book/findBook`,
    method: 'get'
  });
}

function importAll(params) {
  return request({
    url: '/book/importAll',
    method: 'post',
    data: params
  });
}

function deleteOne(id) {
  return request({
    url: `/book/delete/${id}`,
    method: 'delete'
  });
}

function suspendChange(id) {
  return request({
    url: `/book/suspendChange/${id}`,
    method: 'post',
  });
}

export default {
  query,
  findBook,
  deleteOne,
  importAll,
  add,
  update,
  show,
  suspendChange
};